// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/stability.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/stability/stability.js';

mount([g0]);
